// Cart keys are either a bare product id ("42") for products with no color
// variants, or "<productId>::<colorId>" so the same product can sit in the
// cart more than once — once per chosen color.
export const makeCartKey = (productId, colorId) =>
  colorId ? `${productId}::${colorId}` : `${productId}`;

export const parseCartKey = (key) => {
  const [productId, colorId] = String(key).split("::");
  return { productId: Number(productId), colorId: colorId || null };
};

export const findColorInProduct = (product, colorId) =>
  colorId ? product?.colors?.find((c) => c._id === colorId) || null : null;
